angular.module('forms').directive('apFormQuestionImmunizationHistory',[
        '$q',
        '$rootScope',
        'FormsId',
        'FormsService',
        'ListService',
        function (
            $q,
            $rootScope,
            FormsId,
            FormsService,
            ListService
            ) {
            'use strict';

            return {
                restrict: 'E',
                templateUrl: '/forms/views/directives/apFormQuestionImmunizationHistory.html',
                scope: {
                    // Use '@' for one way binding.  String value is returned.
                    // Use '=' for two way binding.  An object is returned.
                    // Use '&' for a method.
                    questionnaireSectionId: '=questionnaireSectionId',
                    questionnaireSection: '=questionnaireSection',
                    loading: '=loading'
                },
                controller: function($scope) {
                    $scope.currentSectionId = '';
                    $scope.adultVaccineList = '';
                    $scope.pediatricVaccineList = '';

                    $scope.$watch('questionnaireSectionId', function() {
                        if ($scope.currentSectionId === '') {
                            return;
                        }

                        if ($scope.currentSectionId !== $scope.questionnaireSectionId) {
                            loadView();
                        }
                    });


                    function getAdultVaccineList(subFindTableId) {
                        return ListService.getList('subfindtableitems/patient-history-vaccine-adult/' + subFindTableId)
                            .then(function (data) {
                                $scope.adultVaccineList = data;

                                if ($scope.questionnaireSection.ImmunizationHistoryAnswers.ImmunizationAdultAnswers.length <= 0) {
                                    _.forEach($scope.adultVaccineList, function(vaccineCard) {
                                        $scope.questionnaireSection.ImmunizationHistoryAnswers.ImmunizationAdultAnswers
                                            .push(FormsService.getNewImmunizationHistoryAnswer(
                                                true,
                                                false,
                                                vaccineCard));
                                    });
                                }
                            });
                    }


                    function getPediatricVaccineList(subFindTableId) {
                        return ListService.getList('subfindtableitems/patient-history-vaccine-pediatric/' + subFindTableId)
                            .then(function (data) {
                                $scope.pediatricVaccineList = data;

                                if ($scope.questionnaireSection.ImmunizationHistoryAnswers.ImmunizationPediatricAnswers.length <= 0) {
                                    _.forEach($scope.pediatricVaccineList, function(vaccineCard) {
                                        $scope.questionnaireSection.ImmunizationHistoryAnswers.ImmunizationPediatricAnswers
                                            .push(FormsService.getNewImmunizationHistoryAnswer(
                                                false,          // IsAdultCard
                                                true,           // IsPediatricCard
                                                vaccineCard));
                                    });
                                }
                            });
                    }


                    function loadView() {
                        $rootScope.setupDirectiveScope($scope);
                        $scope.removeHttpError();
                        var adultVaccineListPromise = getAdultVaccineList($scope.questionnaireSection.AdultVaccineAdminSubFindTableId);
                        var pediatricVaccineListPromise = getPediatricVaccineList($scope.questionnaireSection.PediatricVaccineAdminSubFindTableId);

                        $q.all([adultVaccineListPromise, pediatricVaccineListPromise]).then(function () {
                            $scope.currentSectionId = $scope.questionnaireSectionId;
                        }).catch(function (response) {
                            $scope.addHttpError(response, '', 'listData');
                        }).finally(function () {
                            $scope.loading = false;
                        });
                    }
                    loadView();


                    $scope.adultTimeFrameSelectedCallback = function adultTimeFrameSelectedCallback(timeFrameId, onsetTimeFrameId) {
                        var ids = timeFrameId.split('_');
                        if (ids.length === 2) {
                            var vaccineAdminId = ids[0];
                            var vaccineAdminItemId = ids[1];

                            var immunizationCard = _.find($scope.questionnaireSection.ImmunizationHistoryAnswers.ImmunizationAdultAnswers, {VaccineAdminId: vaccineAdminId});
                            if (immunizationCard) {
                                var immunizationItem = _.find(immunizationCard.ImmunizationAnswers, {VaccineAdminItemId: vaccineAdminItemId});
                                if (immunizationItem) {
                                    if ((onsetTimeFrameId.toUpperCase() === FormsId.TimeFrameId.Clear) || (onsetTimeFrameId === '')) {
                                        immunizationItem.Selected = false;
                                        immunizationItem.Notes = '';
                                    } else {
                                        immunizationItem.Selected = true;
                                    }
                                }
                            }
                        }
                    };


                    $scope.pediatricTimeFrameSelectedCallback = function pediatricTimeFrameSelectedCallback(timeFrameId, onsetTimeFrameId) {
                        var ids = timeFrameId.split('_');
                        if (ids.length === 2) {
                            var vaccineAdminId = ids[0];
                            var vaccineAdminItemId = ids[1];

                            var immunizationCard = _.find($scope.questionnaireSection.ImmunizationHistoryAnswers.ImmunizationPediatricAnswers, {VaccineAdminId: vaccineAdminId});
                            if (immunizationCard) {
                                var immunizationItem = _.find(immunizationCard.ImmunizationAnswers, {VaccineAdminItemId: vaccineAdminItemId});
                                if (immunizationItem) {
                                    if ((onsetTimeFrameId.toUpperCase() === FormsId.TimeFrameId.Clear) || (onsetTimeFrameId === '')) {
                                        immunizationItem.Selected = false;
                                        immunizationItem.Notes = '';
                                    } else {
                                        immunizationItem.Selected = true;
                                    }
                                }
                            }
                        }
                    };

                }
            };
        }
    ]
);